import type { Attachment } from '@medplum/fhirtypes'
import { Button } from '@seen/ui'
import { IconExternalLink, IconLink } from '@tabler/icons-react'
import type { JSX } from 'react'
import { RichTextEditor } from '#src/components/rich-text-editor/RichTextEditor.tsx'
import { useDebouncedCallback } from '#src/hooks/useDebouncedCallback.ts'

interface AttachmentExternalLinkDisplayProps {
  attachment: Attachment
  onTitleChange?: (title: string) => void
}

export function AttachmentExternalLinkDisplay({
  attachment,
  onTitleChange,
}: AttachmentExternalLinkDisplayProps): JSX.Element {
  const debouncedOnTitleChange = useDebouncedCallback(
    onTitleChange ?? (() => {}),
    1000
  )

  const title = attachment.title || 'External Link'

  return (
    <div className="overflow-hidden rounded-lg border bg-muted">
      <div className="flex items-center gap-3 px-4 py-3">
        <div className="shrink-0 text-muted-foreground">
          <IconLink className="h-4 w-4" />
        </div>
        <div className="min-w-0 flex-1">
          {onTitleChange ? (
            <RichTextEditor
              variant="unstyled"
              className="truncate text-sm font-medium"
              value={title}
              onChange={debouncedOnTitleChange}
            />
          ) : (
            <p className="truncate text-sm font-medium">{title}</p>
          )}
          <p className="truncate text-xs text-muted-foreground">
            {attachment.url}
          </p>
        </div>
        <div className="flex shrink-0 gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => window.open(attachment.url, '_blank')}
            title="Open in new tab"
          >
            <IconExternalLink className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  )
}
